import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language === 'ru' ? 'ru' : 'en';

  const toggleLang = () => {
    const newLang = currentLang === 'ru' ? 'en' : 'ru';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLang}
      className="fixed top-4 right-4 z-[70] flex items-center gap-1.5 px-3 py-1.5 glass-pill rounded-full
                 text-[#00D4FF] text-xs font-medium transition-all duration-300 hover:scale-105 active:scale-95"
    >
      <Globe size={13} />
      <span className="uppercase tracking-wider">{currentLang === 'ru' ? 'RU' : 'EN'}</span>
    </button>
  );
}
